var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViguetasT180(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d4c4c;}.cls-2{fill:#b8b8b7;}.cls-3{fill:#cfcfcf;}.cls-4{clip-path:url(#clippath-1);}.cls-5{fill:#9c9b9b;fill-rule:evenodd;}.cls-6{fill:none;}.cls-7{fill:#a4a3a4;}.cls-8{fill:#009ee2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 551.08,
    cy: 540,
    r: 447.99
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 1080,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 551.08,
    cy: 540,
    r: 447.99
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "287.88 967.52 1053.46 535.36 1052.15 440.88 287.85 873.95 287.88 967.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.93,666.06L998.54,232.42c6.18-3.56,10.64-26.95,10.88-34.08l1.33-40.31L250.01,592.53l-7.09,73.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "217.41 819.28 988.67 377.06 986.45 259.25 225.34 696.09 217.41 819.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.85,873.95l764.3-433.08-32.84-25.11c-12.69-11.06-23.09-24.49-30.62-39.55h0L215.58,816.75l72.26,57.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "217.41 701.21 986.45 259.25 1001.55 228.91 236.59 668.89 217.41 701.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "250.24 592.4 1010.74 158.03 876.36 77.84 113.34 507.58 250.24 592.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.78 761.97 185.34 719.51 133.17 694.17 51.09 732 105.78 761.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M287.89,874.09c-19.69-15.5-51.03-32.99-59.7-58.32-9.11-26.63-1.54-62.28-1.95-89.37-.31-20.99-4.55-36.73,11.82-52.03,19.43-18.16,13.8-57.15,12.08-82.1-45.86-27.92-91.42-56.32-136.96-84.75-8.26,32.95-4.37,62.87,6.73,94.67,4.46,10.95,10.9,23.09,10.6,35.22-.23,9.08-4,18.33-5.16,27.25-2.94,22.61-5.82,45.92-9.37,68.39-1.86,11.75-5.32,19.47-18.71,14.6-15.13-5.56-29.98-11.62-44.71-18.15-.5,30.62-.56,61.24-.29,91.86,78.56,48.67,157.18,97.25,235.61,146.15-.32-31.14-.4-62.28,0-93.42Zm-177.13-52.48c-5.98-4.7-10.01-12.3-9.89-18.14,1.14-5.22,6.37-5.8,12.37-2.11,4.97,4.01,9.76,10.77,9.62,16.61-.14,5.85-5.1,7.94-12.09,3.64Zm70.04-228.63c5.96,4.65,9.76,11.96,9.53,17.62-.23,5.65-6.33,5.65-12.31,1.99-4.94-3.96-9.82-10.68-9.62-16.36,1.21-5.07,6.4-6.91,12.39-3.24Zm-13.81,246.23c-4.7-3.86-9.3-10.58-9.09-16.09,1.17-4.92,6.12-6.42,11.83-2.91,5.67,4.39,9.28,11.17,9.04,16.68-.24,5.51-6.1,5.82-11.79,2.32Zm56.12,52.48c-5.14-4.19-10.05-11.34-9.83-17.15,1.27-6.17,6.51-7.7,12.69-2.93,6.19,4.77,10.3,12.1,10.1,17.95-.2,5.85-6.75,5.96-12.96,2.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 180.18,
    cy: 602.95,
    rx: 10.35,
    ry: 15.43,
    transform: "translate(-394.02 345.46) rotate(-49.21)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 111.58,
    cy: 812.1,
    rx: 10.35,
    ry: 15.43,
    transform: "translate(-576.16 366.04) rotate(-49.21)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 223.61,
    cy: 882.24,
    rx: 10.35,
    ry: 16.15,
    transform: "translate(-590.42 475.17) rotate(-49.21)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 169.33,
    cy: 828.52,
    rx: 10.41,
    ry: 15.53,
    transform: "translate(-568.57 415.45) rotate(-49.21)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M757.7,684.71c-29.12-13.56-33.33-40.46-23.4-63.01l-446.16,252.7,.04,93.68,485.33-273.84c-4.84-2.89-12.47-7.98-15.81-9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M768.61,334.94c-5.88-4.37-11.11-10.26-15.1-18.26-1.49-2.99-2.79-6.01-4.12-9.02L250.25,592.63l-7.1,73.62L781.16,357.62c-4.17-7.57-8.24-15.19-12.54-22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M811.45,418.73c-6.18-14.75-13.24-29.47-20.85-44.03-.34-.66-.73-1.29-1.08-1.95L225.52,696.32l-7.93,123.34L800.65,485.49c4.37-22.15,7.95-44.41,10.8-66.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M772.22,586.9c9.3-31.11,20.44-62,27.01-93.66,.65-3.13,1.12-6.29,1.74-9.43L215.76,817.13l72.38,57.27,446.16-252.7c6.93-15.74,20.69-29.38,37.92-34.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M780.53,356.49L236.79,669.09l-19.2,32.36L789.58,372.86c-2.9-5.52-6.04-10.92-9.06-16.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M742.61,290.7c-20.5-34.31-41-68.6-58.73-104.32L113.19,507.51l137.29,84.98,498.91-284.84c-2.48-5.62-4.78-11.27-6.78-16.96Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.77 762.28 185.46 719.77 133.2 694.4 51.76 729.92 105.77 762.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.19,874.54c-19.72-15.51-51.12-33.03-59.8-58.39-9.12-26.66-1.55-62.36-1.95-89.48-.31-21.02-4.55-36.78,11.84-52.1,19.46-18.18,13.83-57.22,12.1-82.2-45.94-27.95-91.57-56.39-137.19-84.85-8.27,32.99-4.38,62.95,6.74,94.79,4.47,10.96,10.92,23.11,10.61,35.26-.23,9.09-4,18.35-5.17,27.28-2.95,22.64-5.83,45.97-9.39,68.48-1.86,11.77-5.34,19.49-18.74,14.62-15.15-5.56-30.03-11.64-44.79-18.17-.5,30.66-.56,61.31-.29,91.98,78.69,48.74,157.45,97.38,236,146.33-.32-31.18-.4-62.36,0-93.54Zm-177.43-52.55c-5.99-4.7-10.03-12.31-9.91-18.16,1.15-5.22,6.38-5.81,12.39-2.12,4.98,4.02,9.78,10.78,9.63,16.63-.14,5.85-5.11,7.95-12.11,3.65Zm70.16-228.91c5.97,4.65,9.77,11.98,9.55,17.64-.23,5.66-6.34,5.66-12.33,1.99-4.95-3.97-9.83-10.69-9.63-16.38,1.21-5.08,6.41-6.92,12.41-3.25Zm-13.83,246.53c-4.71-3.87-9.32-10.6-9.1-16.11,1.17-4.93,6.13-6.43,11.85-2.92,5.68,4.4,9.3,11.18,9.06,16.7-.24,5.52-6.12,5.82-11.81,2.33Zm56.22,52.54c-5.15-4.2-10.07-11.35-9.84-17.18,1.27-6.17,6.52-7.71,12.72-2.93,6.2,4.77,10.32,12.11,10.11,17.97-.2,5.86-6.76,5.97-12.99,2.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 180.29,
    cy: 603.06,
    rx: 10.36,
    ry: 15.46,
    transform: "translate(-394.21 345.9) rotate(-49.24)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 111.58,
    cy: 812.48,
    rx: 10.36,
    ry: 15.46,
    transform: "translate(-576.69 366.55) rotate(-49.24)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 223.8,
    cy: 882.7,
    rx: 10.36,
    ry: 16.18,
    transform: "translate(-590.91 475.88) rotate(-49.24)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 169.42,
    cy: 828.91,
    rx: 10.42,
    ry: 15.55,
    transform: "translate(-569.06 416.07) rotate(-49.24)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViguetasT180);
export default __webpack_public_path__ + "static/media/viguetas T180.b2df161db89febb0cf142e1eaa33b24b.svg";
export { ForwardRef as ReactComponent };